export function faqExpand(question) {
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'faq_expand',
      event_category: 'faq',
      event_action: 'expand',
      event_label: question,
    },
  ]);
}

export function faqContact() {
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'faq_contact',
      event_category: 'faq',
      event_action: 'contact',
    },
  ]);
}

export function faqFeedback(buttonLabel, question) {
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'faq_feedback',
      event_category: 'faq',
      event_action: 'feedback',
      event_label: `${buttonLabel} - ${question}`,
    },
  ]);
}
